exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._37f2GxKDsLSyr_j6Cet-xZ{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._37f2GxKDsLSyr_j6Cet-xZ{margin-top:0}", ""]);

// exports
exports.locals = {
	"description": "_37f2GxKDsLSyr_j6Cet-xZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/view/owa-options-controls/lib/components/OptionDescription.scss
// module id = 4933
// module chunks = 2